<template>
  <div class="chart-container" id="exchange-chart">
    <fullscreen @change="fullscreenChange" ref="fullscreen">
      <div class="chart-option position-relative">
        <div class="time-option position-relative" v-show="chartActive == 1">
          <template v-if="multipleChart">
            <div class="select-box-mul-chart">
              <select-box
                class="time"
                v-model="selectedPair"
                :placeholder="$t('common.no_select')"
                :options="pairs"
                isReturnObject
              />
            </div>

            <div class="select-box-mul-chart">
              <select-box
                class="time"
                id="search_select_dt"
                v-model="selectedTime"
                :placeholder="$t('exchange.basic.label_minute')"
                :options="times()"
              />
            </div>
          </template>
          <template v-else>
            <div>
              <select-box
                class="time"
                v-model="selectedMinute"
                :placeholder="$t('exchange.basic.label_minute')"
                :options="minutesOptions"
                :classFocused="{ 'active-time': timeActive === 1 }"
                :active="timeActive === 1"
                :is-icon-drop-down2="true"
              />
            </div>
            <div>
              <select-box
                class="time"
                v-model="selectedHour"
                :placeholder="$t('exchange.basic.label_hour')"
                :options="hours()"
                :classFocused="{ 'active-time': timeActive === 2 }"
                :active="timeActive === 2"
                :is-icon-drop-down2="true"
              />
            </div>
            <div
              class="time div-time time-filter"
              :class="{ 'active-time': timeActive == 3 }"
              @click="onChangeResolution('D')"
            >
              1D
            </div>
            <div
              class="time div-time time-filter"
              :class="{ 'active-time': timeActive == 4 }"
              @click="onChangeResolution('W')"
            >
              1W
            </div>
            <!-- API load data for chart does't support -->
            <!-- <div class="time div-time time-filter" :class="{'active-time':(timeActive == 5)}" @click="onChangeResolution('M')">1M</div> -->
          </template>

          <div
            v-click-outside="clickOutMenuTradingView"
            class="tooltip-dot d-block d-xxl-none"
          >
            <div
              @click="isShowToolChart = !isShowToolChart"
              class="position-relative tooltip-dot d-block d-xxl-none"
            >
              ...
            </div>
            <div
              class="d-flex d-xxl-none mt-0 position-absolute minimize-tooltip"
              v-if="isShowToolChart"
            >
              <div
                class="time div-time button-icon"
                v-on:click.stop="showIndicatorDialog()"
              >
                <span class="icon-chart1"></span>
              </div>
              <div
                class="time div-time button-icon"
                v-on:click.stop="showChartPropertiesDialog()"
              >
                <span class="icon-setting"></span>
              </div>
              <div
                class="time div-time button-icon group_favered"
                :class="{ active: showFavoredList == true }"
                @click="onshowFavoredList()"
              >
                <div class="btn btn-favored">
                  <span
                    class="icon"
                    :class="{
                      'icon-heikin-ashi2': activeFavoredItem === 2,
                      'icon-bar': activeFavoredItem === 1,
                      'icon-heikin-ashi3': activeFavoredItem === 3,
                      'icon-heikin-ashi': activeFavoredItem === 4,
                      'icon-line2': activeFavoredItem === 5,
                      'icon-line3': activeFavoredItem === 6,
                    }"
                  ></span>
                  <i class="icon-arrow1 icon_drop"></i>
                </div>
                <div
                  class="box_favored_list clearfix"
                  v-show="showFavoredList == true"
                >
                  <ul class="favored_lit">
                    <li
                      class="item"
                      @click="(activeFavoredItem = 1), showSetBarStyle(0)"
                    >
                      <i class="icon icon-bar"></i>
                      <span class="name">{{ $t("barstyle_chart.bars") }}</span>
                    </li>
                    <li
                      class="item"
                      @click="(activeFavoredItem = 2), showSetBarStyle(1)"
                    >
                      <i class="icon icon-heikin-ashi2"></i>
                      <span class="name">{{
                        $t("barstyle_chart.candles")
                      }}</span>
                    </li>
                    <li
                      class="item"
                      @click="(activeFavoredItem = 3), showSetBarStyle(9)"
                    >
                      <i class="icon icon-heikin-ashi3"></i>
                      <span class="name">{{
                        $t("barstyle_chart.hollow_candles")
                      }}</span>
                    </li>
                    <li
                      class="item"
                      @click="(activeFavoredItem = 4), showSetBarStyle(8)"
                    >
                      <i class="icon icon-heikin-ashi"></i>
                      <span class="name">{{
                        $t("barstyle_chart.heikin_ashi")
                      }}</span>
                    </li>
                    <li
                      class="item"
                      @click="(activeFavoredItem = 5), showSetBarStyle(2)"
                    >
                      <i class="icon icon-line2"></i>
                      <span class="name">{{ $t("barstyle_chart.line") }}</span>
                    </li>
                    <li
                      class="item"
                      @click="(activeFavoredItem = 6), showSetBarStyle(3)"
                    >
                      <i class="icon icon-line3"></i>
                      <span class="name">{{ $t("barstyle_chart.area") }}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="time div-time button-icon">
                <span
                  class="icon-screen"
                  @click="toggleFullScreen"
                  :class="{
                    'icon-expad': !fullscreen,
                    'icon-exit-full-screen': fullscreen,
                  }"
                ></span>
              </div>
              <div
                class="time div-time button-icon"
                @click.stop="onSaveTrandingChartConfiguration()"
                id="btn-upload-chart"
              >
                <span class="icon-upload"></span>
                <span class="tooltip-upload">{{
                  $t("barstyle_chart.save_chart")
                }}</span>
              </div>
              <div
                class="time div-time button-icon"
                @click.stop="onReloadTrandingChart()"
                id="btn-download-chart"
              >
                <span class="icon-download"></span>
                <span class="tooltip-download">{{
                  $t("barstyle_chart.load_chart")
                }}</span>
              </div>
              <div class="chart-type d-flex d-sm-none">
                <span
                  class="icon-close1"
                  @click.stop="onCloseChart()"
                  v-if="multipleChart && !fullscreen"
                />
                <div class="chart-tab">
                  <!-- <a class="tab-element" href="/mul-charts" target="_blank" v-if="!multipleChart">{{ $t('exchange.basic.chart.btn_add_chart') }}</a> -->
                  <div
                    class="tab-element"
                    :class="{ 'active-tab': chartActive == 1 }"
                    @click="chartActive = 1"
                  >
                    {{ $t("exchange.basic.chart.candle") }}
                  </div>
                  <div
                    class="tab-element"
                    :class="{ 'active-tab': chartActive == 2 }"
                    @click="chartActive = 2"
                  >
                    {{ $t("exchange.basic.chart.depth") }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="d-none d-xxl-flex mt-0" style="margin-left: 11px">
            <div
              class="time div-time button-icon"
              v-on:click.stop="showIndicatorDialog()"
            >
              <span class="icon-chart1"></span>
            </div>
            <div
              class="time div-time button-icon"
              v-on:click.stop="showChartPropertiesDialog()"
            >
              <span class="icon-setting"></span>
            </div>
            <div
              class="time div-time button-icon group_favered"
              :class="{ active: showFavoredList == true }"
              @click="onshowFavoredList()"
            >
              <div class="btn btn-favored">
                <span
                  class="icon"
                  :class="{
                    'icon-heikin-ashi2': activeFavoredItem === 2,
                    'icon-bar': activeFavoredItem === 1,
                    'icon-heikin-ashi3': activeFavoredItem === 3,
                    'icon-heikin-ashi': activeFavoredItem === 4,
                    'icon-line2': activeFavoredItem === 5,
                    'icon-line3': activeFavoredItem === 6,
                  }"
                ></span>
                <i class="icon-arrow1 icon_drop"></i>
              </div>
              <div
                class="box_favored_list clearfix"
                v-show="showFavoredList == true"
              >
                <ul class="favored_lit">
                  <li
                    class="item"
                    @click="(activeFavoredItem = 1), showSetBarStyle(0)"
                  >
                    <i class="icon icon-bar"></i>
                    <span class="name">{{ $t("barstyle_chart.bars") }}</span>
                  </li>
                  <li
                    class="item"
                    @click="(activeFavoredItem = 2), showSetBarStyle(1)"
                  >
                    <i class="icon icon-heikin-ashi2"></i>
                    <span class="name">{{ $t("barstyle_chart.candles") }}</span>
                  </li>
                  <li
                    class="item"
                    @click="(activeFavoredItem = 3), showSetBarStyle(9)"
                  >
                    <i class="icon icon-heikin-ashi3"></i>
                    <span class="name">{{
                      $t("barstyle_chart.hollow_candles")
                    }}</span>
                  </li>
                  <li
                    class="item"
                    @click="(activeFavoredItem = 4), showSetBarStyle(8)"
                  >
                    <i class="icon icon-heikin-ashi"></i>
                    <span class="name">{{
                      $t("barstyle_chart.heikin_ashi")
                    }}</span>
                  </li>
                  <li
                    class="item"
                    @click="(activeFavoredItem = 5), showSetBarStyle(2)"
                  >
                    <i class="icon icon-line2"></i>
                    <span class="name">{{ $t("barstyle_chart.line") }}</span>
                  </li>
                  <li
                    class="item"
                    @click="(activeFavoredItem = 6), showSetBarStyle(3)"
                  >
                    <i class="icon icon-line3"></i>
                    <span class="name">{{ $t("barstyle_chart.area") }}</span>
                  </li>
                </ul>
              </div>
            </div>

            <div
              class="time div-time button-icon"
              @click.stop="onSaveTrandingChartConfiguration()"
              id="btn-upload-chart"
            >
              <span class="icon-upload"></span>
              <span class="tooltip-upload">{{
                $t("barstyle_chart.save_chart")
              }}</span>
            </div>
            <div
              class="time div-time button-icon"
              @click.stop="onReloadTrandingChart()"
              id="btn-download-chart"
            >
              <span class="icon-download"></span>
              <span class="tooltip-download">{{
                $t("barstyle_chart.load_chart")
              }}</span>
            </div>
          </div>
        </div>

        <div
          :class="{
            'd-none d-sm-flex': chartActive == 1,
            'chart-type-position': chartActive == 2,
          }"
          class="chart-type position-absolute"
        >
          <span
            class="icon-close1"
            @click.stop="onCloseChart()"
            v-if="multipleChart && !fullscreen"
          />
          <div class="chart-tab h-100 d-fex align-items-center">
            <!-- <a class="tab-element" href="/mul-charts" target="_blank" v-if="!multipleChart">{{ $t('exchange.basic.chart.btn_add_chart') }}</a> -->
            <div
              class="tab-element"
              :class="{ 'active-tab': chartActive == 1 }"
              @click="chartActive = 1"
            >
              {{ $t("exchange.basic.chart.candle") }}
            </div>
            <div
              class="tab-element"
              :class="{ 'active-tab': chartActive == 2 }"
              @click="chartActive = 2"
            >
              {{ $t("exchange.basic.chart.depth") }}
            </div>
            <div
              @click="toggleFullScreen"
              class="icon-screen p-0"
              :class="{
                'icon-expand': !fullscreen,
                'icon-exit-expand': fullscreen,
              }"
            ></div>
          </div>
        </div>
      </div>
      <div class="chart-content" :class="{ 'chart-full-screen': fullscreen }">
        <trading-view-chart
          :symbol="symbol"
          :resolution.sync="resolution"
          :min-tick="minTick"
          multipleChart
          ref="tradingView"
          v-show="chartActive === 1"
        >
        </trading-view-chart>
        <iframe
          v-show="chartActive === 2"
          class="webview-depth-iframe"
          :src="webviewDepthChartUrl"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </div>
    </fullscreen>
  </div>
</template>

<script>
import rf from "@/request/RequestFactory";
import TradingViewChart from "./TradingViewChart";
import LocalStorageUtils from "@/common/LocalStorageUtils";
import SelectBox from "@/components/shared_components/common/SelectBox";
import Const from "@/common/Const";
import { mapState } from "vuex";

const DAY = "D";
const WEEK = "W";
const MONTH = "M";

export default {
  components: {
    TradingViewChart,
    SelectBox,
  },
  props: {
    keyChart: { type: Number, default: 1 },
    multipleChart: { type: Boolean, default: false },
    changeTabFromHome: { type: String, default: "market" },
  },
  data() {
    return {
      currency: this.$route.query.currency || Const.DEFAULT_CURRENCY,
      coin: this.$route.query.coin || Const.DEFAULT_COIN,

      resolution:
        LocalStorageUtils.loadChart("trading_chart")?.resolution || "60",
      minTick: "default",

      selectedMinute: null,
      selectedHour: "60",
      isSelectMinute: true,
      chartActive: 1,
      timeActive: 2,
      fullscreen: false,

      // It's used for multiple charts.
      pairs: [],
      selectedPair: null,
      selectedTime: "60",

      /*button show Favored List*/
      showFavoredList: false,
      activeFavoredItem: 2,
      isShowToolChart: false,

      // custom var
      unlockMinutesChart: false,
    };
  },
  computed: {
    symbol() {
      return (
        this.toUpperCase(this.coin) + "/" + this.toUpperCase(this.currency)
      );
    },
    webviewDepthChartUrl() {
      const coin = String(this.coin || "").toLowerCase();
      const currency = String(this.currency || "").toLowerCase();
      const lang =
        (this.$i18n && this.$i18n.locale) ||
        (window?.i18n && window.i18n.locale) ||
        "en";
      // const isDark =
      //   typeof document !== "undefined" &&
      //   document.body &&
      //   document.body.classList &&
      //   document.body.classList.contains("dark-theme");
      // const theme = isDark ? "dark" : "light";
      return `https://sota-exchange.sotatek.works/webview/chart/depth?coin=${coin}&currency=${currency}&resolution=${this.resolution}&theme=dark&lang=${lang}`;
    },
    ...mapState({
      masterData: (state) => state.masterdata,
    }),
    minutesOptions() {
      let data = Const.MINUTES;
      if (!this.unlockMinutesChart) data = data.slice(3, 5);
      return window._.map(data, (item) => {
        const name = this.formatTime(item);
        return { id: `${item}`, name: name };
      });
    },
  },
  watch: {
    resolution() {
      this.saveDataLocalStorage();
    },
    changeTabFromHome(newValue) {
      this.isShowToolChart = false;
      return newValue === this.changeTabFromHome;
    },

    selectedMinute(newMinute) {
      if (!newMinute || this.multipleChart) {
        return;
      }
      this.timeActive = 1;
      this.resolution = newMinute;
      this.selectedHour = null;
    },

    selectedHour(newHour) {
      if (!newHour || this.multipleChart) {
        return;
      }
      this.timeActive = 2;
      this.resolution = newHour;
      this.selectedMinute = null;
    },

    selectedTime(newTime) {
      if (!newTime || !this.multipleChart) {
        return;
      }
      this.resolution = newTime;
    },

    $route(to, from) {
      this.currency = this.$route.query.currency || Const.DEFAULT_CURRENCY;
      this.coin = this.$route.query.coin || Const.DEFAULT_COIN;

      this.onChangedPairCurrency();
    },

    selectedPair(newValue) {
      if (!this.multipleChart) {
        return;
      }
      this.coin = newValue.coin;
      this.currency = newValue.currency;
      this.updateMinTick();
      this.onChangedPairInDepthChart();
    },
  },
  methods: {
    clickOutMenuTradingView() {
      this.isShowToolChart = false;
    },
    getEventHandlers() {
      return {
        SpotSelectedPairMarket: this.onSpotSelectedPairMarket,
      };
    },

    onSpotSelectedPairMarket(pair) {
      this.currency = pair.currency;
      this.coin = pair.coin;

      let foundPair = window._.find(this.pairs, (item) => {
        return item.coin == this.coin && item.currency == this.currency;
      });

      if (foundPair) {
        this.selectedPair = foundPair;
        this.updateMinTick();
        // Depth chart is loaded via iframe and reacts to URL changes.
      }
    },

    hours() {
      return window._.map(Const.HOURS, (item) => {
        const name = this.formatTime(item);
        return { id: `${item}`, name: name };
      });
    },

    times() {
      const arr = [
        { id: "D", name: window.i18n.t("exchange.basic.time.one_day") },
        { id: "W", name: window.i18n.t("exchange.basic.time.one_week") },
        { id: "M", name: window.i18n.t("exchange.basic.time.one_month") },
      ];
      return window._.concat(this.minutesOptions, this.hours(), arr);
    },

    formatTime(time) {
      time = parseInt(time);
      if (time >= 60) {
        let hours = time / 60;
        return window.i18n.t(
          hours > 1 ? "exchange.basic.time.hours" : "exchange.basic.time.hour",
          { number: hours },
        );
      }
      return window.i18n.t(
        time > 1 ? "exchange.basic.time.minutes" : "exchange.basic.time.minute",
        { number: time },
      );
    },

    onChangedPairCurrency() {
      this.updateMinTick();
      this.getDataLocalStorage();

      // update depth chart
      this.onChangedPairInDepthChart();
    },

    onChangeResolution(time) {
      this.timeActive = this.getTimeActive(time);
      this.resolution = time;
      this.selectedMinute = null;
      this.selectedHour = null;
    },

    onCloseChart() {
      ConfirmationModal.show({
        type: "warning",
        title: "",
        content: window.i18n.t("exchange.basic.chart.msg_close_chart"),
        btnCancelLabel: window.i18n.t("common.action.no"),
        btnConfirmLabel: window.i18n.t("common.action.yes"),
        onConfirm: () => {
          this.$emit("closeChart", this.keyChart);
          this.fullscreen = false;
        },
        onCancel: () => {},
      });
    },

    onChangedPairInDepthChart() {
      // Depth chart is loaded via iframe and reacts to URL changes,
      // so no imperative reload is needed here.
    },

    redrawChart() {
      this.$nextTick(() => {
        // Depth chart is loaded via iframe; nothing to redraw here.
      });
    },

    getTimeActive(time) {
      switch (time) {
        case DAY:
          return 3;
        case WEEK:
          return 4;
        case MONTH:
          return 5;
      }
      throw "Selection tab not correct";
    },

    toggleFullScreen() {
      this.$refs["fullscreen"].toggle();
    },

    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
    },

    toUpperCase(value) {
      return value.toUpperCase();
    },

    async updateMinTick() {
      if (!this.masterData) {
        this.minTick = "default";
        return;
      }
      let setting = window._.find(this.masterData.coin_settings, (setting) => {
        return setting.currency == this.currency && setting.coin == this.coin;
      });

      // If setting null, try re-call MasterData from API
      if (!setting) {
        let immediate = true;
        await rf
          .getRequest("MasterdataRequest")
          .getAll(immediate)
          .then((res) => {
            setting = window._.find(res.coin_settings, (setting) => {
              return (
                setting.currency == this.currency && setting.coin == this.coin
              );
            });
          });
      }

      const newMinTick = setting ? 1 / setting.price_precision : 0.001;
      this.minTick = `${newMinTick}`;
    },

    saveDataLocalStorage() {
      const data = {
        selectedMinute: this.selectedMinute,
        selectedHour: this.selectedHour,
        resolution: this.resolution,
        timeActive: this.timeActive,
      };
      LocalStorageUtils.saveItem("trading_chart", data);
    },

    getDataLocalStorage() {
      // const data = LocalStorageUtils.getItem('trading_chart');
      const data = LocalStorageUtils.loadChart("trading_chart");
      if (!data) {
        return;
      }

      this.selectedMinute = data.selectedMinute;
      this.selectedHour = data.selectedHour;
      this.resolution = data.resolution;
      this.timeActive = data.timeActive;
    },

    showIndicatorDialog() {
      if (!window._.isEmpty(this.$refs.tradingView)) {
        this.$refs.tradingView.showIndicatorDialog();
      }
    },

    onSaveTrandingChartConfiguration() {
      if (!window._.isEmpty(this.$refs.tradingView)) {
        this.$refs.tradingView.saveTradingChartConfiguration();

        const data = {
          selectedMinute: this.selectedMinute,
          selectedHour: this.selectedHour,
          resolution: this.resolution,
          timeActive: this.timeActive,
        };

        LocalStorageUtils.saveChart("trading_chart", JSON.stringify(data));
      }
    },

    onReloadTrandingChart() {
      if (!window._.isEmpty(this.$refs.tradingView)) {
        this.$refs.tradingView.reloadTrandingChart();

        this.resolution =
          LocalStorageUtils.loadChart("trading_chart")?.resolution;
        this.selectedMinute =
          LocalStorageUtils.loadChart("trading_chart")?.selectedMinute;
        this.selectedHour =
          LocalStorageUtils.loadChart("trading_chart")?.selectedHour;
      }
    },

    showSetBarStyle(type) {
      if (!window._.isEmpty(this.$refs.tradingView)) {
        this.$refs.tradingView.setBarStyle(type);
      }
    },

    showChartPropertiesDialog() {
      if (!window._.isEmpty(this.$refs.tradingView)) {
        this.$refs.tradingView.showChartPropertiesDialog();
      }
    },

    onshowFavoredList() {
      this.showFavoredList = !this.showFavoredList;
    },

    initPairs() {
      window._.forEach(this.masterData.coin_settings, (setting) => {
        const item = {
          coin: setting.coin,
          currency: setting.currency,
          id: setting.id,
          name: `<b>${this.toUpperCase(setting.coin)}</b> / ${this.toUpperCase(
            setting.currency,
          )}`,
        };
        this.pairs.push(item);
      });
      // Set select first
      this.selectedPair = this.pairs[0];
    },
  },
  created() {
    // this.resolution = this.selectedHour;
    this.resolution;
    this.updateMinTick();
    this.initPairs();
    this.getDataLocalStorage();
    if (process?.env?.NODE_ENV === "development") {
      window.unlockMinutesChart = () =>
        (this.unlockMinutesChart = !this.unlockMinutesChart);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/variables";

.webview-depth-iframe {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}

.dark-theme {
  .chart-option {
    background-color: $color-black-shark !important;
    border-bottom: 4px solid $color-wood-smoke !important;
  }
  .icon-expand {
    background: $color-storm-grey;
  }
  .icon-exit-expand {
    background: $color-storm-grey;
  }
  .time-filter {
    color: $color-auro-metal !important;
  }
}

#exchange-chart {
  .chart-option {
    .time-option {
      ::v-deep {
        .list_search_select {
          .full_name_coin_select {
            font-size: 14px;
          }
        }
      }
    }
  }
}

.icon-expand {
  width: 14px;
  height: 14px;
  background-color: $color-gray-dark;
  -webkit-mask-image: url("@/assets//images/icons/icon-expand.svg");
  mask-image: url("@/assets//images/icons/icon-expand.svg");
  -webkit-mask-repeat: no-repeat;
}
.icon-exit-expand {
  width: 14px;
  height: 14px;
  background-color: $color-gray-dark;
  -webkit-mask-image: url("@/assets//images/icons/icon-exit-expand.svg");
  mask-image: url("@/assets//images/icons/icon-exit-expand.svg");
  -webkit-mask-repeat: no-repeat;
}

$borderColor: #bbbbbb;
$heightOption: 40px;
#btn-upload-chart {
  position: relative;
  .tooltip-upload {
    position: absolute;
    top: 100%;
    margin-top: 5px;
    z-index: 5;
    background: rgba(255, 255, 255, 0.8);
    white-space: nowrap;
    left: 50%;
    font-size: 15px;
    padding: 5px 5px;
    line-height: 20px;
    border-radius: 3px;
    color: #000;
    width: 120px;
    text-align: center;
    margin-left: -60px;
    display: none;
  }
  &:hover {
    .tooltip-upload {
      display: block;
    }
  }
}
#btn-download-chart {
  position: relative;
  .tooltip-download {
    position: absolute;
    top: 100%;
    margin-top: 5px;
    z-index: 5;
    background: rgba(255, 255, 255, 0.8);
    white-space: nowrap;
    left: 50%;
    font-size: 15px;
    padding: 5px 5px;
    line-height: 20px;
    border-radius: 3px;
    color: #000;
    width: 120px;
    text-align: center;
    margin-left: -60px;
    display: none;
  }
  &:hover {
    .tooltip-download {
      display: block;
    }
  }
}
.chart-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  & > :first-child {
    width: 100%;
    height: 100%;
  }
  .fullscreen {
    background: $color-mirage !important;
    overflow-y: hidden !important;
  }
  .chart-option {
    min-width: 393px;
    background-color: $color-gray-alabaster;
    padding: 0px 10px;
    height: $heightOption;
    border-bottom: 1px solid $color-alabaster;
    line-height: 28px;
    font-size: $font-smaller;
    color: $color-grey;

    .tooltip-dot {
      text-align: center;
      margin-left: auto;
      min-width: 35px;
      cursor: pointer;
    }
    .minimize-tooltip {
      top: 35px;
      // right: 16px;
      padding: 10px 0;
      padding-left: 20px;
      background: white;
      width: 250px;
      border: solid 1px $color-gray-dark;
      flex-wrap: wrap;
      background: var(--background-current_coin);
    }

    .time-option {
      height: 100%;
      float: left;
      ::v-deep {
        .sc_search_select .group_search_select .list_search_select {
          background: var(--bgr-pagination);

          li {
            span {
              color: var(--text-primary-color);
            }
            &:hover {
              span {
                color: $color-caribbean-green;
              }
            }
          }
        }
        .sc_search_select .group_search_select .button_drop_search {
          span {
            font-size: 10px;
          }
          .list_search_select {
            background: var(--bgr-pagination);
          }
          .full_name_coin_select {
            color: var(--text-primary-color);
          }
        }
        //background: var(--bgr-pagination);
      }
      div {
        float: left;
        height: 100%;
        display: flex;
        align-items: center;
        ::v-deep {
          .group_search_select {
            height: 100%;
            .button_drop_search {
              float: left;
              height: 100%;
              align-items: center;
              display: flex;
              margin-right: 11.34px;
              border: none;
              padding: 0;
            }
          }
        }

        select {
          height: 100%;
          padding-left: 5px;
          -webkit-appearance: none;
          border: none;
          border-right: 1px solid $borderColor;
          // padding-top: 3px;
          padding-bottom: 3px;
          -webkit-border-radius: 0px;
        }
      }
      .select-box-mul-chart {
        border-right: 1px solid $borderColor;
      }
      .time {
        &.div-time {
          font-size: 10px;
          border-right: 0px;
          display: flex;
          align-items: center;
          border-radius: 3px;
          margin-right: 11.34px;
          cursor: pointer;
          color: var(--text-primary-color);

          &:hover {
            color: $color-aqua-green;
          }
        }
        &.button-icon {
          cursor: pointer;
          font-size: 10px;
          .icon_drop {
            font-size: $font-mini-mini;
            float: right;
            line-height: 26px;
            margin-left: 5px;
          }
          &:hover {
            color: $color-aqua-green;
            .icon-download,
            .icon-upload {
              &:before {
                color: $color-aqua-green;
              }
            }
          }
        }
        &.active-time {
          color: $color-aqua-green !important;
        }
      }
      .time-filter {
        color: $color-gray-dark;
      }
      .group_favered {
        position: relative;
        .btn-favored {
          border: 0px;
          margin: 0 0 0 0;
          padding: 0 0 0 0;
          line-height: 20px;
          background-color: transparent;
          display: flex;
          .icon {
            font-size: 10px;
            display: inline-block;
            float: left;
            margin: 4px 0px;
          }
          .icon_drop {
            line-height: 25px;
            height: 25px;
            float: right;
            padding-top: 2px;
            font-size: 9px;
          }
        }
        .box_favored_list {
          position: absolute;
          top: 100%;
          right: 0px;
          width: 156px;
          z-index: 999;
          margin-top: 5px;
          height: auto;
          .favored_lit {
            background-color: var(--bgr-pagination);
            margin: 0;
            padding: 5px 0px;
            li.item {
              display: block;
              width: 100%;
              line-height: 20px;
              cursor: pointer;
              padding: 3px 14px;
              font-size: $font-root;
              overflow: hidden;
              color: var(--text-primary-color);

              &:hover {
                color: $color-aqua-green;
                .icon {
                  &:after,
                  &:before {
                    color: $color-aqua-green;
                  }
                }
              }
              .icon {
                display: inline-block;
                float: left;
                font-size: $font-big;
                line-height: 20px;
                margin-right: 5px;
                width: 20px;
              }
              .name {
                display: inline-block;
                float: left;
                line-height: 20px;
                font-size: $font-root;
                width: calc(100% - 25px);
              }
            }
          }
        }
        &.active,
        &:hover {
          .btn-favored {
            color: $color-aqua-green;
          }
        }
        &.active {
          .btn-favored {
            .icon_drop {
              -ms-transform: rotate(180deg); /* IE 9 */
              -webkit-transform: rotate(180deg); /* Safari prior 9.0 */
              transform: rotate(180deg); /* Standard syntax */
              padding-top: 0px;
              padding-bottom: 18px;
            }
          }
        }
      }
    }
    .chart-type-position {
      right: 18px !important;
    }

    .chart-type {
      float: right;
      height: 100%;
      line-height: $heightOption;
      right: 18px;
      .total-aml-remaining {
        align-self: center;
        margin-right: -6px;
        font-family: $font-family-roboto;
        font-size: $font-smaller;
        color: $color-green;
        span {
          font-family: $font-family-roboto-bold;
        }
      }
      .icon-close1 {
        color: $color-white;
        float: right;
        line-height: $heightOption;
        padding-left: 9px;
        padding-right: 9px;
        cursor: pointer;
        background: $color-grey;
      }
      .icon-screen {
        float: right;
        padding-left: 9px;
        padding-right: 9px;
        cursor: pointer;
        line-height: $heightOption;
      }
      .chart-tab {
        cursor: pointer;
        margin: 0;
        float: right;
        .tab-element {
          border-right: 0px;
          float: left;
          padding-left: 8px;
          padding-right: 8px;
          font-size: 10px;
          color: var(--text-close);
          font-family: $font-family-roboto-medium;
          &.active-tab {
            background: transparent;
            color: $color-caribbean-green;
          }
        }
        a {
          color: $color-grey-dusty;
          &:hover {
            color: $color-corn;
          }
        }
      }
    }
  }
  .chart-content {
    height: calc(100% - #{$heightOption});
    width: 100%;
    .vue-highcharts {
      box-shadow: none !important;
      border: none !important;
    }
    &.chart-full-screen {
      height: calc(100% - #{$heightOption}) !important;
    }
  }
}
@media only screen and (max-width: 992px) {
  .dark-theme {
    .chart-option {
      border-bottom: 1px solid var(--color-border-right) !important;
      border-top: 1px solid var(--color-border-right) !important;
    }
  }
  .chart-container .chart-option {
    //border: 1px solid $color-gray-alto;
    padding-right: 0;
    padding-left: 20px;
    border-bottom: 1px solid $color-gray-alto;
    border-top: 1px solid $color-gray-alto;

    .time-option {
      width: 100%;
      ::v-deep {
        .sc_search_select .group_search_select .button_drop_search span {
          font-size: 10px;
        }
      }
    }

    .tab-element {
      padding-right: 0;
    }
    .time-option {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .div-time {
        margin-top: 0;
        height: auto;
        font-size: 10px;
      }
    }
  }
}
@media only screen and (max-width: 992px) {
  .chart-container .chart-option {
    //border: 1px solid $color-gray-alto;
    padding-right: 0;

    .time-option {
      width: 100%;
    }

    .tab-element {
      padding-right: 0;
    }
    .time-option {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      div {
        margin-top: 0;
        height: auto;
      }
    }
  }
}

@media only screen and (max-width: 992px) {
  .chart-container .chart-option {
    min-width: 325px;
  }
  .chart-container .chart-option .chart-type {
    right: 30px;
  }
  .chart-container .chart-option {
    .time-option {
      .div-time {
        font-size: 12px;
        font-weight: 600;
        color: $color-grey-dark;
      }
      ::v-deep {
        .sc_search_select .group_search_select .button_drop_search span {
          font-weight: 600;
          font-size: 12px;
          color: $color-gray-dark;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.chart-content {
  .tv-side-toolbar {
    background-color: red;
  }
}
</style>
